<template>
    <img src="/vue/images/facebook.png" @click="shareFB">
</template>
<script>

    window.fbAsyncInit = function () {
        FB.init({
            appId: '422289938612780',
            autoLogAppEvents: true,
            xfbml: true,
            version: 'v3.3'
        });
    };

    (function (d, s, id) {
        var js,
            fjs = d.getElementsByTagName(s)[0];
        if (d.getElementById(id)) {
            return;
        }
        js = d.createElement(s);
        js.id = id;
        js.src = "//connect.facebook.net/en_US/sdk.js";
        fjs.parentNode.insertBefore(js, fjs);
    })(document, "script", "facebook-jssdk");


    import functions from "./functions.js";

    export default {
        mixins: [functions],
        props: [
            'is_success'
        ],
        methods: {
            shareFB() {
                FB.ui(
                    {
                        method: 'share',
                        href: 'https://cvweb.ru/' + this.$store.getters.locale,
                    },
                    // callback
                    (response) => {
                        if (response && !response.error_message) {
                            this.$emit('input', true);
                        } else {
                            this.$emit('input', false);
                        }
                    }
                );
            }
        }
    };
</script>



// WEBPACK FOOTER //
// resources/js/components/share/facebook.vue